import { isLocalUrl } from '../utils.js';

export default function upcomingEvents() {
  const widgetName = 'upcomingEvents';
  const widgetOpts = upcomingEventsOpts;
  const $widget = $(`#${widgetName}`);

  // Label for buttons
  const moreLabel = 'Buy Tickets';
  const buyLabel = 'Buy Premium >';

  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Description, URL, PurchaseURL } = widgetData[x];
      const eventDate = getDate(Description);
      const $cardItem = $(this);
      const $cardDescription = $cardItem.find('.card-widget-description');
      const $cardImage = $cardItem.find('.image-container');

      if (Description) {
        $cardDescription.html(eventDate);
        $cardDescription.appendTo($cardImage);
      } else {
        $cardDescription.remove();
      }

      updateCardButtons($cardItem, URL, PurchaseURL);
    });
  }

  function getDate(widgetDate) {
    if (!widgetDate) return '';

    const createDateHTML = (month, day) => {
      const monthName = new Date(0, month - 1).toLocaleString('default', { month: 'short' });
      return `
      <div class="date">
        <span class="month">${monthName}</span>
        <span class="number">${Number.parseInt(day, 10)}</span>
      </div>
    `;
    };

    if (widgetDate.includes(' - ')) {
      const [startDate, endDate] = widgetDate.split(' - ');
      const [startMonth, startDay] = startDate.split('/');
      const [endMonth, endDay] = endDate.split('/');

      return `
      ${createDateHTML(startMonth, startDay)}
      <span class="separator">-</span>
      ${createDateHTML(endMonth, endDay)}
    `;
    }

    const [month, day] = widgetDate.split('/');
    return createDateHTML(month, day);
  }

  // function to create buttons
  function updateCardButtons($item, btn1, btn2) {
    const targetMore = isLocalUrl(btn1) ? '' : '_blank';
    const targetBuy = isLocalUrl(btn2) ? '' : '_blank';

    // if btn1 and btn2 are empty, remove buttonwrap
    if (!btn1 && !btn2) {
      $item.addClass('no-buttons');
      return;
    }

    $item.find('.buttonwrap').empty();
    $item
      .find('.buttonwrap')
      .append(btn1 ? `<a href="${btn1}" class="button" target=${targetMore}>${moreLabel}</a>` : '');
    $item
      .find('.buttonwrap')
      .append(
        btn2 ? `<a href="${btn2}" class="button btn-link" target=${targetBuy}>${buyLabel}</a>` : '',
      );
  }

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [],
    showDescription: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: false,
    maxItemsVisible: 4,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
        console.log(data.items);
      } else {
        $('.events-section').remove();
      }
    },
  });
}
